import { render, staticRenderFns } from "./markdown-text.vue?vue&type=template&id=61b90fc3"
import script from "./markdown-text.vue?vue&type=script&lang=ts"
export * from "./markdown-text.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports